/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { Trans } from "react-i18next";
import Select from "react-select";
import i18n from "i18next";
import Helpers from "util/helpers";
import { LANGUAGE_CODES } from "util/constant";
import requireAuth from "components/hoc/requireAuth";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import Trainings from "./Trainings";
import toastr from "toastr";
import { api } from "api";

class TrainingCatalogContainer extends Component {
  state = {
    selectedServiceType: null,
    selectedTrainingGroupType: null,
    trainingGroupTypes: [],
    trainings: [],
    billable: false,
    employeeCode: "",
  };

  componentDidMount() {
    this.fetchData();
    this.fetchTrainingGroupTypeOptions();
  }

  fetchData = () => {
    this.props.onProcessBegin();
    api
      .get(`/api/training-catalog/get`)
      .then((response) => {
        this.setState({
          trainings: response.data.data.trainings,
          billable: response.data.data.billable,
          employeeCode: response.data.data.employeeCode,
        });
      })
      .catch((err) => {
        console.log(err);
        toastr.error(err.response.data.message);
      })
      .finally(() => {
        this.props.onProcessEnd();
      });
  };

  fetchTrainingGroupTypeOptions = () => {
    api
      .get(`/api/training-catalog/get-traninig-groups`)
      .then((response) => {
        const options = [];
        options.push({ value: "0", label: i18n.t("10614") });
        const langCode = Helpers.getLangCode(
          localStorage.getItem("i18nextLng")
        );

        const _langCode =
          langCode === LANGUAGE_CODES.English ||
            langCode === LANGUAGE_CODES.Turkish
            ? langCode
            : LANGUAGE_CODES.English;

        response.data.data.trainingGroups[_langCode].forEach((e) => {
          options.push({ value: e.id, label: e.name });
        });

        this.setState({ trainingGroupTypes: options });
      })
      .catch((err) => {
        console.log(err);
        toastr.error(err.response.data.message);
      });
  };

  handleServiceTypeSelect = (e) => {
    this.setState({ selectedServiceType: e.value });
  };

  renderServiceTypeCombo = () => {
    /*
      Satış = 15;
      Satış Sonrası = 10
      Ortak = 20
    */

    const options = [
      { value: "0", label: i18n.t("10614") },
      { value: "15", label: i18n.t("10611") },
      { value: "10", label: i18n.t("10612") },
      { value: "20", label: i18n.t("10613") },
    ];

    return (
      <Select
        placeholder={i18n.t("10521")}
        options={options}
        onChange={(e) => this.handleServiceTypeSelect(e)}
        value={options.find(
          (o) => o.value === String(this.state.selectedServiceType)
        )}
      />
    );
  };

  handleTrainingGroupType = (e) => {
    this.setState({ selectedTrainingGroupType: e.value });
  };

  renderTrainingGroupTypeCombo = () => {
    return (
      <Select
        placeholder={i18n.t("10521")}
        options={this.state.trainingGroupTypes}
        onChange={(e) => this.handleTrainingGroupType(e)}
        value={this.state.trainingGroupTypes.find(
          (o) => o.value === String(this.state.selectedTrainingGroupType)
        )}
      />
    );
  };

  renderTabbedContent = () => {
    let filteredData = [...this.state.trainings];

    if (
      this.state.selectedServiceType !== null &&
      this.state.selectedServiceType !== "0"
    ) {
      filteredData = filteredData.filter((item) => {
        return (
          item.affectedByTrainingCode !== null &&
          item.affectedByTrainingCode.value ===
          parseInt(this.state.selectedServiceType)
        );
      });
    }

    if (
      this.state.selectedTrainingGroupType !== null &&
      this.state.selectedTrainingGroupType !== "0"
    ) {
      filteredData = filteredData.filter((item) => {
        return (
          item.trainingGroupType !== null &&
          item.trainingGroupType.id === this.state.selectedTrainingGroupType
        );
      });
    }

    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <Trainings
          data={filteredData}
          employeeCode={this.state.employeeCode}
          billable={this.state.billable}
          refresh={() => this.fetchData()}
        />
      </div>
    );
  };

  render() {
    return (
      <section className="profilArea my-3">
        {this.props.spinner}
        <div className="container">
          <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <Trans desc="Eğitim ve Gelişim">10025</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans desc="Eğitim Kataloğu">trainingcatalog</Trans>
                </li>
              </ul>
            </div>
          </div>
          <div className="row d-flex d-sm-flex d-md-none d-lg-none py-4 topRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <div className="profilBaslik">
                <Trans desc="Eğitim Kataloğu">trainingcatalog</Trans>
              </div>
            </div>
          </div>

          <div className="row calculateArea">
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 my-1">
              <div className="ml-2">
                <label>
                  <Trans desc="Servis Tipi">10615</Trans>
                </label>
                {this.renderServiceTypeCombo()}
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 my-1">
              <div className="ml-2">
                <label>
                  <Trans desc="Grup">trainingcatalog_group</Trans>
                </label>
                {this.renderTrainingGroupTypeCombo()}
              </div>
            </div>
          </div>

          <div className="row py-4 bottomRow">{this.renderTabbedContent()}</div>
        </div>
      </section>
    );
  }
}

export default requireAuth(
  containsLongRunningProcess(TrainingCatalogContainer)
);
